export const DEFAULT_HEADERS = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};